let id = 0;

export const createRuntimeUniqueId = (): number => {
  id = id + 1;

  return id;
};
